import { render, staticRenderFns } from "./salesLabel.vue?vue&type=template&id=5914c8d2&scoped=true&"
import script from "./salesLabel.vue?vue&type=script&lang=js&"
export * from "./salesLabel.vue?vue&type=script&lang=js&"
import style0 from "./salesLabel.vue?vue&type=style&index=0&id=5914c8d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914c8d2",
  null
  
)

export default component.exports